"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WITHDRAW_STATUS = exports.BILL_STATUS_OPTIONS = exports.BILL_STATUS = void 0;
var BILL_STATUS = exports.BILL_STATUS = {
  0: {
    label: '待确认',
    type: 'warning'
  },
  1: {
    label: '待打款',
    type: 'primary'
  },
  2: {
    label: '已结算',
    type: 'success'
  },
  3: {
    label: '结算失败',
    type: 'danger'
  }
};
var BILL_STATUS_OPTIONS = exports.BILL_STATUS_OPTIONS = [{
  label: '全部',
  value: ''
}, {
  label: '待确认',
  value: 0
}, {
  label: '待打款',
  value: 1
}, {
  label: '已结算',
  value: 2
}, {
  label: '结算失败',
  value: 3
}];
var WITHDRAW_STATUS = exports.WITHDRAW_STATUS = {
  0: '申请中',
  1: '已划入商户钱包',
  2: '失败',
  3: '已走平台提现'
};